const getSafeZoomLevel = (zoomLevel: number): number => (
  Number.isFinite(zoomLevel) && zoomLevel > 0 ? zoomLevel : 1
);

export const getZoomAdjustedPx = (value: number, zoomLevel: number): string => (
  `calc(${value}px / ${getSafeZoomLevel(zoomLevel)})`
);

export const getZoomAdjustedCssValue = (value: string, zoomLevel: number): string => (
  `calc((${value}) / ${getSafeZoomLevel(zoomLevel)})`
);
